export function Loader({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-8 text-tg-hint">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-tg-hint border-t-transparent" />
      {label && <p className="text-sm">{label}</p>}
    </div>
  );
}
